<main>
  <nb-card>
    <nb-card-header i18n>
      <h6>404. Страница не найдена</h6>
    </nb-card-header>
    <nb-card-body>
      <p i18n>Вы находитесь здесь, потому что ввели адрес страницы, которая не существует или была перемещена по другому адресу</p>
      <p i18n><a href="/">Вернуться на главную страницу</a></p>
    </nb-card-body>
  </nb-card>
</main>
